import { useMemo } from "react";
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';

export const useGetColumns = ({metodos}) => {
    
    const columns = [
        {
            field: 'idEvaluacion',
            headerName: '#',
            flex: 140
        },
        {
            field: 'delegacion',
            headerName: 'Delegación',
            flex: 150
        },
        {
            field: 'paciente',
            headerName: 'Paciente',
            flex: 200
        },
        {
            field: 'cod_Cliente',
            headerName: 'Cod. Cliente',
            flex: 150
        },
        {
            field: 'cliente',
            headerName: 'Cliente',
            flex: 200
        },
        {
            field: 'fDesde',
            headerName: 'F. Desde',
            type: 'date',
            flex: 130
        },
        {
            field: 'fHasta',
            headerName: 'F. Hasta',
            type: 'date',
            flex: 130
        },
        {
            field: 'idConformidad',
            headerName: 'Conformidad',
            flex: 180
        },
        {
            field: 'fechaGestion',
            headerName: 'F. Gestión',
            type: 'date',
            flex: 130
        },
        {
            field: 'idMetodoEnvio',
            headerName: 'Método',
            flex: 100,
            valueGetter: (idMetodoEnvio) => {
                const metodo = metodos?.find(m => m.id === idMetodoEnvio);
                return metodo ? metodo.displayName : '-';
            }
        },
        {
            field: 'fechaProcesamiento',
            headerName: 'Procesado',
            flex: 150,
            align: 'center',
            valueGetter: (fechaProcesamiento) => !!fechaProcesamiento ? 'Sí' : 'No'
        }
    ]

    const configuratedColumns = useMemo(() => generateColumnsDefaultConfiguration(columns, true), [metodos]);

    return configuratedColumns;
}